import React, { useEffect, useMemo, useState } from "react"
import { Button, Col, Form, Input, Row, Select } from "antd"

import modStyl from './index.module.scss'
import utils from "../../../../../utils/utils"
import { readTargetName } from "../../../../../utils/storage"
import { GetApplyProjectList } from "../../../../../services/apply/ApplyService"
import { ClosingManagementPayload } from "../../../../../services/dct/visit"
import ImportModal from "../import-modal"

interface Option {
  label: string
  value: string
}

const colCols = {
  span: 8
}
const fieldCols = {
  labelCol: {
    span: 6
  },
  wrapperCol: {
    span: 18
  }
}

interface ConditionProps {
  type: number
  onSearch: (params?: ClosingManagementPayload)=> void
}
const Condition: React.FC<ConditionProps> = ({ type, onSearch })=> {

  const [form] = Form.useForm()

  const [spinning, setSpinning] = useState(false)
  const [loading, setLoading] = useState(false)

  const [options, setOptions] = useState<Option[]>([])

  const [visible, setVisible] = useState(false)

  // 
  const targetName = useMemo(()=> readTargetName(), [])

  const takePayload = ()=> {
    return {
      ...form.getFieldsValue(),
      type,
    }
  }

  const submitControl = ()=> {
    onSearch(form.getFieldsValue())
  }

  const resetControl = ()=> {
    form.resetFields()
    if (options.length === 1) {
      form.setFieldValue('projectCode', options[0].value)
    }
    onSearch()
  }

  const exportControl = ()=> {
    setSpinning(true)
    utils.exportPostFun('data/dataSettlementSubject/exportData', takePayload(), ['', '结算数据.xlsx', '废弃数据.xlsx'][type], ()=> {
      setSpinning(false)
    })
  }

  const handleProjectChange = (value?: string)=> {
    form.setFieldValue('visit', undefined)
  }

  const handleVisibleChange = async(opend: boolean)=> {
    if (!opend || options.length > 0) {
      return
    }

    setLoading(true)
    const { code, data } = await GetApplyProjectList()
    setLoading(false)

    if (code !== 0) {
      return
    }

    setOptions(
      data.map(({projectName, projectCode}: any)=> ({
        label: projectName,
        value: projectCode
      }))
    )
    if (data.length === 1) {
      form.setFieldValue('projectCode', data[0].projectCode)
    }
  }

  return (
    <div className={modStyl.wrapper}>
      <Form form={form} >
        <Row gutter={16}>
          <Col {...colCols}>
            <Form.Item {...fieldCols} name="projectCode" label="所属项目">
              <Select
                loading={loading}
                options={options}
                optionFilterProp="label"
                placeholder="请选择"
                onChange={handleProjectChange}
                onDropdownVisibleChange={handleVisibleChange}
                showSearch
                allowClear/>
            </Form.Item>
          </Col>
          <Col {...colCols}>
            <Form.Item {...fieldCols} name="subjectCode" label={`${targetName}编号`}>
              <Input placeholder={`请输入${targetName}编码`} allowClear/>
            </Form.Item>
          </Col>
          <Col {...colCols}>
            <Button onClick={submitControl} type="primary">搜索</Button>
            <Button onClick={resetControl} style={{marginLeft: 10}}>重置</Button>
            <Button loading={spinning} onClick={exportControl} style={{marginLeft: 10}} type="link">导出数据</Button>
            <Button onClick={()=> setVisible(true)} style={{marginLeft: 10}} type="link">导入数据</Button>
          </Col>
        </Row>
      </Form>
      {
        visible && <ImportModal type={type} onReload={onSearch} onClose={()=> setVisible(false)}/>
      }
    </div>
  )
}

export default Condition